import { reducer as agentItemsList } from 'app/pages/AgentSearch/modules/AgentItemsList';

export const reducers = {
    agentItemsList
};
